export default "__VITE_ASSET__k1W5_2iB__"